import { defineMessages } from 'react-intl'

export default defineMessages({
  inputLabel: {
    id: 'SpaceMemberEditPage.UserSearch.Label',
    defaultMessage: 'Search for user to add'
  },
  inputPlaceholder: {
    id: 'SpaceMemberEditPage.UserSearch.Placeholder',
    defaultMessage: 'Employee name or email'
  },
  searchingItem: {
    id: 'SpaceMemberEditPage.UserSearch.SearchingItem',
    defaultMessage: 'Searching...'
  },
  noResultsItem: {
    id: 'SpaceMemberEditPage.UserSearch.NoResultsItem',
    defaultMessage: 'No results...'
  }
})
